// Shared verbatim with mobile/utils/sortOptions.js.

export const SORT_OPTIONS = [
  { id: 'date-asc', sortBy: 'date', sortOrder: 'asc' },
  { id: 'date-desc', sortBy: 'date', sortOrder: 'desc' },
  { id: 'price-asc', sortBy: 'price', sortOrder: 'asc' },
  { id: 'price-desc', sortBy: 'price', sortOrder: 'desc' },
  { id: 'distance-asc', sortBy: 'distance', sortOrder: 'asc', requiresLocation: true }
];

export const DEFAULT_SORT_OPTION = SORT_OPTIONS[0];

export function getSortOptionById(id) {
  return SORT_OPTIONS.find((option) => option.id === id) || DEFAULT_SORT_OPTION;
}
